/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Select_Resume_PlaceholderInputs */

const en_story_bank_select_resume_placeholder = /** @type {(inputs: Story_Bank_Select_Resume_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a resume...`)
};

const de_story_bank_select_resume_placeholder = /** @type {(inputs: Story_Bank_Select_Resume_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a resume...`)
};

const fr_story_bank_select_resume_placeholder = /** @type {(inputs: Story_Bank_Select_Resume_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a resume...`)
};

const es_story_bank_select_resume_placeholder = /** @type {(inputs: Story_Bank_Select_Resume_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a resume...`)
};

const it_story_bank_select_resume_placeholder = /** @type {(inputs: Story_Bank_Select_Resume_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a resume...`)
};

const nl_story_bank_select_resume_placeholder = /** @type {(inputs: Story_Bank_Select_Resume_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a resume...`)
};

const pl_story_bank_select_resume_placeholder = /** @type {(inputs: Story_Bank_Select_Resume_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a resume...`)
};

const fi_story_bank_select_resume_placeholder = /** @type {(inputs: Story_Bank_Select_Resume_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a resume...`)
};

const da_story_bank_select_resume_placeholder = /** @type {(inputs: Story_Bank_Select_Resume_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a resume...`)
};

const sv_story_bank_select_resume_placeholder = /** @type {(inputs: Story_Bank_Select_Resume_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a resume...`)
};

/**
* | output |
* | --- |
* | "Select a resume..." |
*
* @param {Story_Bank_Select_Resume_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_select_resume_placeholder = /** @type {((inputs?: Story_Bank_Select_Resume_PlaceholderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Select_Resume_PlaceholderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_select_resume_placeholder(inputs)
	if (locale === "fr") return fr_story_bank_select_resume_placeholder(inputs)
	if (locale === "es") return es_story_bank_select_resume_placeholder(inputs)
	if (locale === "it") return it_story_bank_select_resume_placeholder(inputs)
	if (locale === "nl") return nl_story_bank_select_resume_placeholder(inputs)
	if (locale === "pl") return pl_story_bank_select_resume_placeholder(inputs)
	if (locale === "fi") return fi_story_bank_select_resume_placeholder(inputs)
	if (locale === "da") return da_story_bank_select_resume_placeholder(inputs)
	if (locale === "sv") return sv_story_bank_select_resume_placeholder(inputs)
	return en_story_bank_select_resume_placeholder(inputs)
});